import
{
    TEAMSSCREEN_LOAD,
    TEAMSSCREEN_UNLOAD,
    TEAMSSCREEN_SET,
} from '../../../../actionDefinitions';
import { createReducer } from '../../../../reducerUtils';

const initialState =
{
    //teamsHierarchy


    //teamsHierarchy
    //[
    //     {
    //         "site": "site1",
    //         "division": "Account Management",
    //         "manager": "managerName1",
    //         "supervisor": "supervisorName1",
    //         "agent": "agentName1"
    //     },
    //     {
    //         "site": "site2",
    //         "division": "Repair",
    //         "manager": "managerName2",
    //         "supervisor": "supervisorName2",
    //         "agent": "agentName2"
    //     },
    //]
};

const handlers = {
    [TEAMSSCREEN_LOAD]: (state, action) =>
    {
        if (action.error)
        {
            return { error: action.payload };
        }
        return { ...action.payload, dataLoaded: true }
    },
    [TEAMSSCREEN_UNLOAD]: () => initialState,
    [TEAMSSCREEN_SET]: (state, action) => action.updatedProps,
};

export default createReducer(initialState, handlers);
